import { useQuery } from '@tanstack/react-query';
import { tagsApi } from 'API/tags-api/tags-api';
import { useMemo } from 'react';
import { PlacerEntityWrapper } from '@placer-ui/types';
import { Complex } from '@placer-ui/types/src/entities/place';
import { placesWithTagsQueryKeys } from 'hooks/queries/tags/tag-keys';
import { ComparisonDates } from 'types/properties-data';
import { DEFAULT_QUERY_STALE_TIME } from 'queries/constant';

export type GetPlacesForTagWithCompareResponse = {
    current: PlacerEntityWrapper<Complex>[];
    compared: PlacerEntityWrapper<Complex>[];
};

export const useGetPlacesForTagWithCompareQuery = ({
    tagId,
    dates,
    enabled = true,
}: {
    tagId: string | undefined;
    dates?: ComparisonDates | undefined;
    enabled?: boolean;
}) => {
    const queryParams = useMemo(
        () => ({
            id: tagId!,
            startDate: dates?.start_date ?? '',
            endDate: dates?.end_date ?? '',
            compareEndDate: dates?.compared_end_date ?? '',
            compareStartDate: dates?.compared_start_date ?? '',
        }),
        [
            dates?.compared_end_date,
            dates?.compared_start_date,
            dates?.end_date,
            dates?.start_date,
            tagId,
        ],
    );

    return useQuery({
        queryKey: placesWithTagsQueryKeys.filters(queryParams),
        enabled: enabled && !!tagId && !!dates,
        staleTime: DEFAULT_QUERY_STALE_TIME,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const { current, compared } = await tagsApi.getPlacesForTag(queryParams);

            return { current, compared };
        },
    });
};
